let authenticated = false; 
let user_name = "";
let user_email = "";
let user_id = -1;
let token = "na";
let language_code = 'es';
let groups = [];
let activeGroupID = -1;
let activeSubgroupID = -1;
let activeRoleID = -1;
export default {
  authenticated() {
    return authenticated;
  },
  get_user_name() {
    return user_name;
  },
  get_user_email() {
    return user_email;
  },
  get_id_group_active() {
    return activeGroupID;
  },
  get_id_subgroup_active() {
    return activeSubgroupID;
  },
  get_id_role_active() {
    return activeRoleID;
  },
  set_id_group_active(val) {
    activeGroupID=val;
  },
  set_id_subgroup_active(val) {
    activeSubgroupID=val;
  },
  set_id_role_active(val) {
    activeRoleID=val;
  },
  get_language() {
    return language_code;
  },
  get_user_id() {
    return user_id;
  },
  get_token() {
    return token;
  },
  get_Groups() {
    return groups;
  },
  set_token(val) {
    token=val;
  },
  set_groups(val) {
    groups=val;
  },
  set_language(val) {
    language_code=val;
  },
  loggedIn() {
    return !!this.authenticated();
  },
  logIn(pUsername,pUseremail,pUser_id,pToken) {
    authenticated = true;
    user_name = pUsername;
    user_email = pUseremail;
    user_id = pUser_id;
    token = pToken;
    localStorage.setItem("token", token);
    return {
        isOk: true,
        data: {username:pUsername}
    };
  },
  logOut() {
    authenticated = false;
    user_name = "";
    user_email = "";
    user_id = -1;
    token = "";
    if (localStorage.getItem("token")) {
        localStorage.removeItem("token");
    }
  }
};
